import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  href = '#compra',
  onClick
}: {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}) {
  const handleClick = (e: React.MouseEvent) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    onClick?.();
  };
  const baseClasses = 'group relative inline-flex items-center justify-center gap-3 px-8 py-5 md:px-12 md:py-6 bg-gradient-to-br from-[#F5C518] via-[#FFD700] to-[#E5B800] text-black text-lg md:text-xl font-black rounded-2xl transition-all duration-500 hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_30px_rgba(245,197,24,0.3)] hover:shadow-[0_0_50px_rgba(245,197,24,0.5)] overflow-hidden border-b-4 border-[#B8860B] hover:border-b-2 hover:translate-y-[2px]';
  return <a href={href} onClick={handleClick} className={`${baseClasses} ${className}`} data-id="element-453">
      {/* Premium inner glow */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-white/20 pointer-events-none" data-id="element-454" />

      {/* Animated border glow */}
      <div className="absolute -inset-[2px] bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-0 group-hover:opacity-100 blur-sm transition-opacity duration-500" data-id="element-455" />

      <Sparkles className="w-5 h-5 md:w-6 md:h-6 relative z-10 animate-pulse text-black/70" data-id="element-456" />
      <span className="relative z-10 text-center uppercase tracking-tight" data-id="element-457">
        {children}
      </span>
      <ArrowRight className="w-6 h-6 md:w-7 md:h-7 relative z-10 group-hover:translate-x-2 transition-transform duration-300 flex-shrink-0" data-id="element-458" />

      {/* Refined shine effect */}
      <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent via-white/60 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-[shine_1.5s_infinite] pointer-events-none" data-id="element-459" />
    </a>;
}